<template>
  <div class="main">
    <el-container class="main-continer">
      <el-header class="header-continer">
        <div class="main-header">
          <div class="left-title">
            <img
              v-if="platformInfo.logoImg"
              :src="platformInfo.logoImg"
              alt=""
            />
            <img v-else src="../../assets/images/logo.png" alt="" />
            <h2 class="header-name">{{ platformInfo.sysName }}</h2>
          </div>
          <div class="loginOff">
            <div class="daiban1">
              <el-badge  class="item" >
                <img style="width: 24px;height: 28px" src="../../assets/images/calculator-line.png" alt="" @click = "calDialogVisible=!calDialogVisible">
              </el-badge>
            </div>

<!--            <el-tooltip content="操作向导" placement="bottom" effect="light">-->
<!--              <i class="el-icon-warning-outline" style="margin-right: 15px;cursor: pointer;font-size: 20px" @click="toGuide"></i>-->
<!--            </el-tooltip>-->
            <div class="daiban1">
              <el-badge :value="myCartNum" class="item" :hidden="myCartNum < 1">
                <img
                  src="../../assets/images/cart.png"
                  alt=""
                  @click="toMyPurchase"
                />
              </el-badge>
            </div>

<!--            <div class="daiban">-->
<!--              <el-badge :value="totalNum" class="item" :hidden="totalNum < 1">-->
<!--                <img @click="toTodos" src="@/assets/images/daiban.png" alt="" />-->
<!--              </el-badge>-->
<!--            </div>-->
            <div class="daiban">
              <el-badge :value="noticeNum" class="item" v-show="noticeNum > 0">
                <img @click="notices" src="@/assets/images/daiban.png" alt="111"/>
              </el-badge>
              <el-badge class="item" value="new"  v-show="hiddenNotice" style="margin-right: 5px;">
                <img @click="notices" src="@/assets/images/daiban.png" alt="111" />
              </el-badge>
              <img @click="notices" src="@/assets/images/daiban.png" alt="111" v-show="hiddenNotice == false && noticeNum == 0"/>
            </div>
            <el-popover
              placement="top-start"
              trigger="click"
              style="display: flex; align-items: center"
            >
              <div style="height: 63px">
                <el-button
                  type="primary"
                  size="mini"
                  style="width: 100%"
                  @click="jump"
                  >个人中心</el-button
                >
                <div style="padding-top: 4px">
                  <el-button
                    type="primary"
                    size="mini"
                    style="width: 100%"
                    @click="logOut"
                    >退出登录</el-button
                  >
                </div>
              </div>
              <img
                slot="reference"
                class="atavar"
                src="../../assets/images/defaultAvatar.png"
                alt=""
              />
            </el-popover>
<!--            <span style="margin-right: 20px" @click="visible = !visible">{{ info.accountName }}</span>-->
            <span style="margin-right: 20px" @click="visible = !visible">{{ info.nickName }}</span>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" style="height:calc(100vh - 70px) ;">
          <el-menu
            :default-active="$route.path + ''"
            text-color="#666666"
            active-text-color="#478AFF"
            :router="true"
            :unique-opened="true"
            @open="handleOpen"
            @select="myJump"
          >
            <!-- 首页 -->
            <!-- <el-menu-item index="1-1">
              <img v-if="activeIndex == item.path" style="width:20px;height:20px;margin-right:10px" :src="item.iconActive" alt="">
              <img v-else style="width:20px;height:20px;margin-right:10px" :src="item.icon" alt="">
              <span :class="activeIndex == item.path?'title-color':''">{{ item.authName }}</span>
            </el-menu-item> -->
            <!--一级菜单-->
            <template v-for="item in navMenuData">
              <template v-if="userPermissions.indexOf(item.id) >= 0">
                <el-submenu
                  v-if="item.children && item.children.length"
                  :index="item.path + ''"
                  :key="item.id"
                >
                  <template slot="title">
                    <img
                      v-if="activeIndex == item.path || activeIndexPath[0] === item.path"
                      style="width: 20px; height: 20px; margin-right: 10px"
                      :src="item.iconActive"
                      alt=""
                    />
                    <img
                      v-else
                      style="width: 20px; height: 20px; margin-right: 10px"
                      :src="item.icon"
                      alt=""
                    />
                    <span
                    :class="activeIndex == item.path || activeIndexPath[0] === item.path ? 'title-color' : ''"
                      >{{ item.authName }}</span
                    >
                    <el-badge v-if="item.id== 103" :is-dot="myCartNum > 0 || confirmOrder > 0" style="margin-top:-15px;"></el-badge>
                    <el-badge v-if="item.id == 108" :is-dot="unCheckedOrder > 0" style="margin-top:-15px;"></el-badge>
                    <el-badge v-if="item.id== 116" :is-dot="yuYueNum > 0 || lendNum > 0" style="margin-top:-15px;"></el-badge>
                  </template>
                  <!--二级菜单-->
                  <template v-for="itemChild in item.children">
                    <template v-if="userPermissions.indexOf(itemChild.id) >= 0">
                      <el-submenu
                        v-if="itemChild.children && itemChild.children.length"
                        :index="itemChild.path + ''"
                        :key="itemChild.id"
                      >
                        <template slot="title">
                          <span>{{ itemChild.authName }}</span>
                        </template>
                        <template v-for="itemChild_child in itemChild.children">
                          <el-menu-item
                            :index="itemChild_child.path + ''"
                            :key="itemChild_child.id"
                            v-if="
                              userPermissions.indexOf(itemChild_child.id) >= 0
                            "
                          >
                            <span slot="title">{{
                              itemChild_child.authName
                            }}</span>
                          </el-menu-item>
                        </template>
                      </el-submenu>
                      <el-menu-item
                        v-else-if="itemChild.id == 122"
                        :key="itemChild.id"
                        :index="itemChild.path"
                        @click="logOut"
                        >{{ itemChild.authName }}</el-menu-item
                      >
                      <el-menu-item
                        v-else
                        :index="itemChild.path + ''"
                        :key="itemChild.id"
                        >{{ itemChild.authName }}
                        <el-badge v-if="itemChild.id == 104" :value="myCartNum" :hidden="myCartNum < 1" style="margin-left: 10px"></el-badge>
                        <el-badge v-if="itemChild.id == 105" :value="confirmOrder" :hidden="confirmOrder < 1" style="margin-left: 10px"></el-badge>
                        <el-badge v-if="itemChild.id == 112" :value="unCheckedOrder" :hidden="unCheckedOrder < 1" style="margin-left: 10px"></el-badge>
                        <el-badge v-if="itemChild.id == 117" :value="yuYueNum" :hidden="yuYueNum < 1" style="margin-left: 10px"></el-badge>
                        <el-badge v-if="itemChild.id == 118" :value="lendNum" :hidden="lendNum < 1" style="margin-left: 10px"></el-badge>
                      </el-menu-item
                      >

                    </template>
                  </template>
                </el-submenu>
                <el-menu-item v-else :index="item.path" :key="item.id">
                  <img
                    v-if="$route.path == item.path"
                    style="width: 20px; height: 20px; margin-right: 10px"
                    :src="item.iconActive"
                    alt=""
                  />
                  <img
                    v-else
                    style="width: 20px; height: 20px; margin-right: 10px"
                    :src="item.icon"
                    alt=""
                  />
                  <span
                    slot="title"
                    :class="$route.path == item.path ? 'title-color' : ''"
                    >{{ item.authName }}</span
                  >
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </el-aside>
        <el-main class="container">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <el-drawer title="-公告栏-" :visible.sync="borrowDrawer" :direction="direction" :show-close="false"
        :before-close="noticeClose">
    <div>
<!--      <div>-->
<!--        <span style = "margin-left: 10px;font-size: 14px;font-weight: 700;">-->
<!--          • 外组借用试剂申请-->
<!--        </span>-->
<!--      </div>-->
<!--      <div class="table_task">-->
<!--        <el-table :data="tableTaskData" :show-header="false" style="width: 100%">-->
<!--          <el-table-column>-->
<!--            <template slot-scope="scope">-->
<!--              <span style="color: #3398F0;font-size: 14px;">- {{scope.row.messageBody}}</span>-->
<!--              <span style="color: #3398F0;font-size: 14px;text-decoration: underline">{{scope.row.remark}}</span>-->
<!--              <span style="margin-left: 10px;">-->
<!--                        <el-button style="height: 22px;padding-top: 4px" size="mini" type="danger"-->
<!--                                   @click="helpCollect(scope.row)">帮他领取</el-button>-->
<!--              </span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </div>-->
      <el-container class="containerRemind">
        <el-header>
          <div>
            <span style="margin-left: 10px;font-size: 15px;font-weight: 700;">
              • 外组借用试剂申请
            </span>
          </div>
        </el-header>
        <el-main>
          <div class="table_task">
            <el-table :data="tableTaskData" :show-header="false" style="width: 100%">
              <el-table-column>
                <template slot-scope="scope">
                  <span style="color: #3398F0;font-size: 14px;">- {{ scope.row.messageBody }}</span>
                  <span style="color: #3398F0;font-size: 14px;text-decoration: underline">{{ scope.row.remark }}</span>
                  <span style="margin-left: 10px;">
                    <el-button style="height: 22px;padding-top: 4px" size="mini" type="danger"
                               @click="helpCollect(scope.row)">帮他领取</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-container>
      <el-container style="margin-top: 50px;">
        <el-header style="height: 40px;">
          <div>
            <span style="margin-left: 10px;font-size: 15px;font-weight: 700;">
              • 试剂入库提醒
            </span>
          </div>
        </el-header>
        <el-main>
          <div class="table_task">
            <el-table v-loading="loading1"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      :data="reagentRemind" :show-header="false" style="width: 100%">
              <el-table-column>
                <template slot-scope="scope">
                  <span style="font-size: 14px;">- {{ scope.row.userName }}有</span>
                  <span style="color: #F18F41;font-size: 14px;text-decoration: underline">{{ scope.row.taskParams }}个试剂</span>
                  <span>{{ scope.row.messageBody }}，请尽快处理</span>
                  <span>
                    <img src="../../assets/images/flashlight-fill.png"/>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-container>
    </div>
    </el-drawer>
    <!-- 备案 -->
    <!-- <div class="record">沪ICP备2021028033号-1</div> -->
    <Calculator v-if="calDialogVisible" @close="handleCloseCal"></Calculator>
  </div>

</template>

<script>
import { EventBus } from "../../config/event-bus.js";
import Calculator from "@/components/calculator";

export default {
  components: {Calculator},
  data() {
    return {
      calDialogVisible:false,
      loading1: false,
      reagentRemind: [],
      dialogVisible: false,
      tableTaskData: [],
      textarea2: null,
      hiddenNotice: false,
      noticeNum: 0,
      selectMessageData: [],
      direction: "rtl",
      noticeList: [],
      activeNames: ['1'],
      //退出登录菜单
      borrowDrawer: false,
      visible: false,
      pathName: "",
      path: "",
      active: 0,
      show: false,
      searchValue: "",
      myCartNum: "",
      activeIndex: "/home",
      activeIndexPath: [],
      userPermissions: "",
      navMenuData: [
        // {
        //   id: 100,
        //   authName: "首页搜索",
        //   path: "/home",
        //   order: 1,
        //   icon: require("../../assets/menu/menuicon02.png"),
        //   iconActive: require("../../assets/menu/menuicon01.png"),
        // },
        // {
        //   id: 101,
        //   authName: "柜机管理",
        //   path: "/cabinetRun",
        //   order: 1,
        //   icon: require("../../assets/menu/menuicon04.png"),
        //   iconActive: require("../../assets/menu/menuicon03.png"),
        //   // children: [
        //   //   {
        //   //     id: 102,
        //   //     order: 1,
        //   //     authName: "柜机管理",
        //   //     path: "/cabinetRun",
        //   //   },
        //   // ],
        // },
        // {
        //   id: 102,
        //   authName: "试剂管理",
        //   path: "/ReagentRun",
        //   icon: require("../../assets/menu/shiji.png"),
        //   iconActive: require("../../assets/menu/shiji2.png"),
        //   // children: [
        //   //   {
        //   //     id: 102,
        //   //     order: 1,
        //   //     authName: "试剂管理",
        //   //     path: "/ReagentRun",
        //   //   },
        //   // ],
        // },
        // {
        //   id: 103,
        //   authName: "我的选购",
        //   path: "/9",
        //   icon: require("../../assets/menu/xuangou.png"),
        //   iconActive: require("../../assets/menu/xuangou2.png"),
        //   order: 9,
        //   children: [
        //     {
        //       id: 104,
        //       authName: "购物车",
        //       path: "/myPurchase",
        //     },
        //     {
        //       id: 105,
        //       authName: "我的订单",
        //       path: "/myOrder",
        //       children: [],
        //       order: 2,
        //     },
        //     {
        //       id: 106,
        //       authName: "我的额度",
        //       path: "/quotaManagement",
        //     },
        //   ],
        // },
        // {
        //   id: 107,
        //   authName: "柜机日志",
        //   path: "/cabinetRecord",
        //   icon: require("../../assets/menu/rizhi.png"),
        //   iconActive: require("../../assets/menu/rizhi2.png"),
        //   // children: [
        //   //   {
        //   //     id: 104,
        //   //     authName: "柜机日志",
        //   //     path: "/cabinetRecord",
        //   //   },
        //   // ]
        // },
        // {
        //   id: 108,
        //   authName: "权限管理",
        //   path: "/3",
        //   order: 3,
        //   icon: require("../../assets/menu/menuicon08.png"),
        //   iconActive: require("../../assets/menu/menuicon07.png"),
        //   children: [
        //     {
        //       id: 109,
        //       authName: "账号管理",
        //       path: "/account",
        //     },
        //     {
        //       id: 110,
        //       authName: "额度分配",
        //       path: "/quotaManagement2",
        //     },
        //     {
        //       id: 111,
        //       authName: "试剂公开",
        //       path: "/reagentPublic",
        //     },
        //     {
        //       id: 112,
        //       authName: "订单审核",
        //       path: "/orderReview",
        //     },
        //   ],
        // },
        // {
        //   id: 113,
        //   authName: "数据统计",
        //   path: "/orders",
        //   order: 4,
        //   icon: require("../../assets/menu/menuicon12.png"),
        //   iconActive: require("../../assets/menu/menuicon11.png"),
        //   children: [
        //     {
        //       id: 114,
        //       authName: "试剂领用统计",
        //       path: "/reagentReceive",
        //     },
        //     {
        //       id: 115,
        //       authName: "订单采购统计",
        //       path: "/orderCensus",
        //     },
        //   ],
        // },
        // {
        //   id: 116,
        //   authName: "我的操作",
        //   path: "/2",
        //   order: 6,
        //   icon: require("../../assets/menu/menuicon06.png"),
        //   iconActive: require("../../assets/menu/menuicon05.png"),
        //   children: [
        //     {
        //       id: 117,
        //       authName: "我的预约",
        //       path: "/borrowInfo",
        //       children: [],
        //       order: null,
        //     },
        //     {
        //       id: 123,
        //       authName: "我的领用",
        //       path: "/myBorrow",
        //       children: [],
        //       order: null,
        //     },
        //     {
        //       id: 124,
        //       authName: "跨组借用",
        //       path: "/myLendOther",
        //       children: [],
        //       order: null,
        //     },
        //     {
        //       id: 118,
        //       authName: "组内转用",
        //       path: "/myLend",
        //       children: [],
        //       order: null,
        //     },
        //
        //   ],
        // },
        //
        // // {
        // //   id: 116,
        // //   authName: "商品管理",
        // //   path: "/2",
        // //   order: 6,
        // //   icon: require("../../assets/menu/menuicon06.png"),
        // //   iconActive: require("../../assets/menu/menuicon05.png"),
        // //   children: [
        // //     {
        // //       id: 117,
        // //       authName: "购买限制管理",
        // //       path: "/buyLimit",
        // //     },
        // //   ],
        // // },
        //
        // //
        // // {
        // //       id: 113,
        // //       authName: "审核管理",
        // //       path: "reports2",
        // //       order: 5,
        // //       icon: require("../../assets/menu/dingdan.png"),
        // //       iconActive: require("../../assets/menu/menuicon11.png"),
        // //       children: [
        // //         // {
        // //         //   id: 115,
        // //         //   authName: "订单审核",
        // //         //   path: "/orderReview",
        // //         // },
        // //          {
        // //           id: 1051,
        // //           authName: "账号审核",
        // //           path: "/account2",
        // //         },
        // //       ],
        // //     },
        // {
        //   id: 119,
        //   authName: "个人中心",
        //   path: "/10",
        //   order: 10,
        //   icon: require("../../assets/menu/menuicon10.png"),
        //   iconActive: require("../../assets/menu/menuicon09.png"),
        //   children: [
        //     {
        //       id: 120,
        //       authName: "我的资料",
        //       path: "/mine",
        //       children: [],
        //     },
        //     {
        //       id: 121,
        //       authName: "我的地址",
        //       path: "/location",
        //       children: [],
        //     },
        //     {
        //       id: 122,
        //       authName: "退出账号",
        //       path: "/quit",
        //       children: [],
        //     },
        //   ],
        // },
      ],
      info: {},
      totalNum: "",
      selectValue: null,
      platformInfo: "",
      pagesData: {
        pageNum: 1,
        pageSize: 10,
        selectValue: null,
      },
      yuYueNum:0,
      unCheckedOrder:0,
      confirmOrder:0,
      lendNum:0,
    };
  },
  created() {
    this.myCartNum = localStorage.getItem("test");
    this.getYuYueNum();
    this.getLoker();
    this.getMyCartNum();
    this.getUnCheckedOrder();
    this.getConfirmOrder();
    this.getLendNum();
    this.noticeListDataNum();
    window.addEventListener("storage", (e) => {
      if (e.key === "test") {
        this.myCartNum = e.newValue;
      }
    });
    this.getDataListNum();
    this.getAllMenu();
  },
  mounted() {
    this.getUserInfo();
    EventBus.$on("showCityName", (msg) => {
      this.myCartNum = msg;
    });
    EventBus.$on("showTodoNum", (msg) => {
      this.totalNum = msg;
    });
    EventBus.$on("yuYueNum", (msg) => {
      this.yuYueNum = msg;
    });
    EventBus.$on("UnCheckedOrder", (msg) => {
      this.unCheckedOrder = msg;
    });
    EventBus.$on("lendNum", (msg) => {
      this.lendNum = msg;
    });
    EventBus.$on("accountName", (msg) => {
      this.info.accountName = msg;
    });
    EventBus.$on("confirmOrder", (msg) => {
      this.confirmOrder = msg;
    });

  },
  methods: {
    handleCloseCal(){
      this.calDialogVisible = false;
    },
    toGuide(){
      localStorage.setItem("open","true");
      this.$router.push("/guide")
    },
    getAllMenu(){
      this.$apiFetch
          .get("/lockerMenu/getAllMenu")
          .then((res) => {
            this.navMenuData = res.data;
            if(null != this.navMenuData && this.navMenuData.length > 0){
              let data = this.navMenuData;
              data.filter((item,index)=>{
                item.icon = require('../../assets/'+item.icon);
                item.iconActive = require('../../assets/'+item.iconActive);
              })
            }
          });
    },
    noticeListDataNum(){
      this.$apiFetch
          .get("/lockerTask/selectOtherBorrowTaskNum")
          .then((res) => {
            const num = res.data;
            if(num > 0){
              this.noticeNum = num;
            }else {
              this.noticeNum = 0;
              this.$apiFetch
                  .get("/lockerTask/getNoBackReagentNum")
                  .then((res) => {
                    this.hiddenNotice = res.data;
                  });
            }
          });
    },
    // noticeChange(val){
    //   const id = val;
    //   if(null == id || '' == id){
    //     return
    //   }
    //   this.$apiFetch
    //       .get("/lockerTask/getMessageTask/"+id)
    //       .then((res) => {
    //         this.textarea2 = null;
    //         this.textarea2 = res.data.messageBody;
    //       });
    // },
    noticeListData(){
      this.$apiFetch.post("/lockerTask/selectOtherBorrowTask", {}).then((res) => {
        this.tableTaskData = res.data;
        //this.noticeChange(this.activeNames);
      });
    },
    reagentRemindData(){
      this.loading1 = true;
      this.$apiFetch.get("/lockerTask/selectReagentRemind").then((res) => {
        this.reagentRemind = res.data;
        this.loading1 = false;
      });
    },
    notices() {
      this.borrowDrawer = true;
      this.noticeListData();
      this.reagentRemindData();
    },
    helpCollect(row){
      const id = row.id;
      if(null == row.id){
        return
      }
      this.$confirm("是否确认帮他领取?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$apiFetch.post("/lockerReagentBorrow/agreeBorrow", {id: id})
            .then((res) => {
              if (!res.data.code) {
                this.borrowDrawer = false;
                // this.$message.success("申领成功，可以扫码出库");
                this.noticeListDataNum();
                this.$notify({
                  title: '操作提示',
                  message: '试剂借用成功',
                  position: 'bottom-right',
                })
              }
            }).catch((error)=> {
        });
        this.borrowDrawer = false;
      }).catch(() => {
      });
    },
    noticeClose(){
      this.borrowDrawer = false;
    },
    //我的预约标记
    getYuYueNum(){
      this.$apiFetch
          .get("/lockerBorrowRecord/selectMarkRecordCount")
          .then((res) => {
            localStorage.setItem("yuYueNum",res.data);
            this.yuYueNum = localStorage.getItem("yuYueNum");
          });
    },
    //我的选购标记
    getMyCartNum() {
      this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
        this.myCartNum = res.data;
        localStorage.setItem("test", res.data)
        EventBus.$emit('showCityName',res.data);
        this.myCartNum = localStorage.getItem("test");
      });
    },
    //未审核订单标记
    getUnCheckedOrder(){
      this.$apiFetch
          .get("/lockerOrders/getUnCheckedOrder")
          .then((res) => {
            localStorage.setItem("UnCheckedOrder",res.data);
            this.unCheckedOrder = localStorage.getItem("UnCheckedOrder");
          });
    },

    //确认收货标记
    getConfirmOrder(){
      this.$apiFetch
          .get("/lockerOrders/getConfirmOrder")
          .then((res) => {
            localStorage.setItem("confirmOrder",res.data);
            this.confirmOrder = localStorage.getItem("confirmOrder");
          });
    },

    //转借申请标记
    getLendNum(){
      this.$apiFetch
          .get("/lockerBorrowRecord/getBorrowNoticeNum")
          .then((res) => {
            localStorage.setItem("lendNum",res.data);
            this.lendNum = localStorage.getItem("lendNum");
          });
    },

    toMyPurchase() {
      this.$router.push({ path: "myPurchase" });
    },
    //获取数据列表
    getDataListNum() {
      this.$apiFetch
        .get("/lockerTask/queryTaskListNumber/" + this.selectValue)
        .then((res) => {
          if (!res.satus) {
            this.totalNum = res.data.total;
          }
        });
    },
    getLoker() {
      this.$apiFetch
        .get("/lockerCopywriting/list")
        .then((data) => {
          this.platformInfo = data.data[0];
          localStorage.setItem(
            "platformInfo",
            JSON.stringify(this.platformInfo)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleOpen(key) {
      // console.log(key, keyPath);
      // this.activeIndex = key;
      // console.log(key);
      // if(key == 'reports2'){
      //   this.activeIndex = '/reports'
      // }
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(value, link) {
      this.active = value;
      this.$router.push(`/${link}`);
    },
    handleSearch() {
      this.active = 1;
      this.$router.push(`/product`);
      this.$store.commit("goodsName", this.searchValue);
    },
    getUserInfo() {
      this.$apiFetch.get("/lockerUser/info?rebuild=1").then((res) => {
        this.info = res.data;
        this.userPermissions = res.data.userPermissions;
        // console.log(
        //   this.userPermissions,
        //   "---------------------------userPermissions"
        // );
        // this.initMenu()
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      });
    },
    jump() {
      if (this.$route.path !== "/mine") {
        this.activeIndex = "/reports";
        this.$router.push("/mine");
      }
    },
    myJump(index, indexPath) {
      this.activeIndex = index;
      this.activeIndexPath = indexPath;
      console.log(index, indexPath);
      // if(indexPath == '/home'){
      //location.href = "/home" + "#reloaded";
      //location.reload();
      // }
    },
    //退出登录
    logOut() {
      localStorage.clear();
      this.$router.push("/");
    },
    //待办事项
    toTodos() {
      this.$router.push("/todos");
    },
    // initMenu(){
    //   let newarr = []
    //   let userPermissions = JSON.parse(this.userPermissions)
    //   this.navMenuData.forEach((res,index)=>{
    //     let child = []
    //     if(userPermissions.indexOf(res.id) != -1 ){
    //       newarr.push(res)
    //       if(res.children.length>0){
    //         res.children.forEach((a,c)=>{
    //           let childchild = []
    //           if(userPermissions.indexOf(res.id) != -1){
    //             child.push(a)
    //             if(a.children.length>0){
    //               a.children.forEach((s)=>{
    //                 if(userPermissions.indexOf(res.id) != -1){
    //                   childchild.push(s)
    //                 }
    //               })
    //             }
    //           }
    //           child[c].children = childchild
    //         })
    //       }
    //      newarr[index].children = child
    //     }
    //   })
    //   this.newNavMenu = newarr
    // }
  },
};
</script>
<style>
.el-textarea.is-disabled .el-textarea__inner {
  background-color: #F5F7FA;
  border-color: #ffffff;
  color: #e6a23c;
  font-size: 14px;
  cursor: not-allowed;
}

.el-collapse-item__header {
  font-size: 14px;
  font-weight: 700;
}

.containerRemind .table_task >>> .el-table__row>td {
  /* 去除表格线 */
  border: none;
}

.containerRemind .table_task >>> .el-table::before {
  /* 去除下边框 */
  height: 0;
}

.containerRemind .table_task {
  margin-left: 10px;
}
.el-drawer__header {
  font-size: 20px;
  font-weight: 600;
}
.table_task .el-table .el-table__cell {
  padding: 8px 0;
  border-bottom: 1px solid #f5f7fa;
}

</style>
<style lang="less" scoped>

.title-color {
  color: rgb(71, 138, 255) !important;
}
.main-header {
  box-shadow: 0px 2px 6px 0px rgba(208, 214, 216, 0.15) !important;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 96%;
  padding: 0 20px;
  align-items: center;
  min-width: 1400px;
}
/deep/.el-header {
  padding: 0 !important;
  img {
    width: 24px;
    margin-right: 8px;
  }
  .atavar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }
  .left-title {
    width: 50%;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      object-fit: cover;
    }
  }
  .loginOff {
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      color: #333333;
      font-weight: 700;
      line-height: 32px;
    }
    .iconright {
      // float: right;
      width: 7px;
      height: 13px;
      margin-left: 15px;
    }
  }
}
/deep/ .el-main {
  padding: 0;
  background-color: #f2f5fa;
}
/deep/ .el-aside {
  .el-menu-item {
    font-size: 16px;
    display: flex;
    align-items: center;
    position: relative;
  }
  .el-menu-item.is-active {
    font-weight: 700;
    background-color: #e7f0ff;
  }
  .el-submenu {
    .el-menu-item {
      padding-left: 28px !important;
      padding-right: 0 !important;
    }

    .el-menu-item::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #cccccc;
      margin-right: 26px;
    }

    .el-menu-item.is-active::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #478aff;
      margin-right: 26px;
    }
  }

  .el-menu-item.is-active::after {
    content: "";
    display: inline-block;
    width: 3px;
    height: 100%;
    background-color: #478aff;
    position: absolute;
    right: 0;
    top: 0;
  }

  .el-submenu__title {
    font-size: 16px;
  }
}
@media screen and (min-width: 1920px) {
  @rf: 1;
  .main-continer {
    .header-continer {
      width: 100%;
      height: 56px * @rf;
      padding: 0 23px * @rf;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-name {
        color: #333333;
        font-size: 20px * @rf;
        font-weight: 700;
        line-height: 56px * @rf;
      }
    }
  }
}
@media screen and (min-width: 1390px) and (max-width: 1919px) {
  @rf: 0.76;
  .main-continer {
    .header-continer {
      width: 100%;
      height: 56px * @rf;
      padding: 0 23px * @rf;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-name {
        color: #333333;
        font-weight: 700;
      }
    }
  }
}

@media screen and (max-width: 1390px) {
  @rf: 0.6;
  .main-continer {
    .header-continer {
      width: 100%;
      height: 56px * @rf;
      padding: 0 23px * @rf;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-name {
        color: #333333;
        font-weight: 700;
      }
    }
  }
}
.main .el-aside {
  background: url(../../assets/images/menubg.png) no-repeat;
  background-position: bottom;
  background-size: 200px 246px;
}
.record {
  position: fixed;
  bottom: 0;
  //left: o;
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}
.daiban {
  display: flex;
  align-items: center;

  img {
    width: 22px;
    height: 24px;
    margin-right: 37px;
  }
}
.daiban1 {
  display: flex;
  align-items: center;
  img {
    width: 22px;
    height: 24px;
    margin-right: 37px;
  }
}

.my-shopping {
  position: absolute;
  bottom: 9px;
  right: 0;
}

.el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 10px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
/deep/.el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 39px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
/deep/.el-badge__content.is-dot{
  height: 10px;
  width: 10px;
}
</style>
